import React, {useEffect, useState} from 'react';
import * as SS from '../styles/shared-styles';
import * as S from './style';

import { Transition } from 'react-transition-group';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { useSelector } from 'react-redux'
import { TrackUserActionAnalytics } from '../../../services/loggedout-api';
import { SetAgeApi , MarkAgeSelectionApi, UserOnboardingDetails } from '../../../services/parent-api';
import { fetchAgeNumberFromAgeAndGrade, getItemFromLocalStorage, sendErrorToSentry,sendEventUsingAvo } from '../../../utils/web-helper';
import { PRE_K_GRADE } from '../../../constant-data/constants';

const AgeSelection = ({isNextStep, goToNextHandler}) => {

  const [animate, setAnimate] = useState(false);

  const { selectedGrade } = useSelector(state => {
    return {
      selectedGrade: state.selectedGrade
    }
  });

  const { setValue } = useExtendedLocalStorage('splashverse-onboarding', '');
  const name = localStorage.getItem('tutoringChildName');
  const onboardingData = getItemFromLocalStorage('splashverse-onboarding');
  const childId = onboardingData && onboardingData.childId;

  const goToNextStep = () => {

    let opt = {};
    let isPrek = false;
    if (selectedGrade==PRE_K_GRADE) {
      isPrek = true;
    }
    opt = {...opt, isPrek}

    goToNextHandler('age_selection', opt);
  }


  useEffect(() => {
    setTimeout(() => {
      setAnimate(true);
    }, 100)
    let params = {
      grade: selectedGrade
    }
    sendEventUsingAvo({methodName: 'ageQuestionScreenViewed',params});
    MarkAgeSelectionApi();

  }, []);

  const clickHandler =  async (age, ageNumber) => {
    let params = {
      clickedOn: age
    }
    sendEventUsingAvo({methodName: 'ageQuestionScreenInteracted',params});
    try {
       await SetAgeApi({
        grade_code: selectedGrade,
        onboarding: true,
        screen_name: name ,
        child_age:age,
      });
    }catch(err){
      console.error(err);
      let errorInfo = {
        extraMsg: 'SetAgeApi failed',
      };
      sendErrorToSentry(err, errorInfo)
    }

    try {
      TrackUserActionAnalytics({
      user_action: 'age_range_selected',
      }, true)
    } catch (e) {
      console.log(e);
    }
    setValue('childAge', age);
    UserOnboardingDetails({
      id: childId,
      grade_code: selectedGrade,
      age: ageNumber,
    })
    goToNextStep();
  }

const handleClick = (index) => {
    let ele = document.getElementById("age-list-li-"+index);
    ele.style.background = '#69D5C1';
    ele.firstChild.style.color = '#17147A';
    clickHandler(ele.innerText, fetchAgeNumberFromAgeAndGrade(selectedGrade, index));
  }

  const ageNumber = ['Less than 3 years old', '3 years old', '4 years old', '5 years old', 'More than 5 years old'];


   const ageListItems = ageNumber.map((age,index) =>
    <li  key = {index.toString()} id = {"age-list-li-" + index} onClick={() => {handleClick(index);}}>
      <span>{age}</span>
    </li>
  );



  return (
    <Transition in={animate} timeout={500}>
      {(state) => (
        <SS.OnboardingStepWrapper state={state} isNextStep={isNextStep}>
          <SS.StepHeader>
            How old is {name}?
          </SS.StepHeader>
          <SS.StepSubheader >
            It will help us to personalise {name}'s experience better
          </SS.StepSubheader>
          <S.ChildNameContainer >
            <S.UlListContainer>
              {ageListItems}
            </S.UlListContainer>
          </S.ChildNameContainer>
        </SS.OnboardingStepWrapper>
      )}
    </Transition>
  )
}

export default AgeSelection;